const KEY = "gf_quest";

export const saveQuest = (q) => localStorage.setItem(KEY, JSON.stringify(q));
export const loadQuest = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
};
